<template>
    <div class="relative w-full overflow-hidden rounded-2xl bg-gradient-to-b from-[#D5B4FA] to-[#8179F7]">
        <!-- highlight -->
        <div
            class="absolute inset-0 bg-[radial-gradient(40%_128px_at_50%_0%,theme(backgroundColor.white/10%),transparent)]"
        ></div>

        <!-- texture -->
        <div class="absolute h-full w-full bg-[url(/images/noise.png)] bg-[size:96px] bg-repeat opacity-[0.025]"></div>

        <div class="relative h-40 w-full">
            <div class="absolute -top-1/2 h-full w-full">
                <!-- tweak variables -->
                <div
                    class="relative flex h-full w-full items-center justify-center [--duration:1.5s] [--scale:1.2] [--baseOpacity:1] [--baseSize:80px] [--opacityStep:0.05] [--sizeStep:64px]"
                >
                    <!-- repeat this element, set `--i` to index -->
                    <div
                        class="ripple absolute rounded-full border border-dashed border-white/50 bg-white/5 [--i:0]"
                    ></div>

                    <div
                        class="ripple absolute rounded-full border border-dashed border-white/50 bg-white/5 [--i:1]"
                    ></div>

                    <div
                        class="ripple absolute rounded-full border border-dashed border-white/50 bg-white/5 [--i:2]"
                    ></div>

                    <div
                        class="ripple absolute rounded-full border border-dashed border-white/50 bg-white/5 [--i:3]"
                    ></div>
                </div>
            </div>
        </div>

        <div class="group relative p-8">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppWellColorful',
};
</script>
